<template>
  <v-card>
    <v-card-text>
      <v-row justify="center" class="pt-5">
        <v-col cols="12" class="text-center">
          <qrcode :value="value" :options="{ width: 200 }"></qrcode>
        </v-col>
        <v-col cols="12" class="text-center">
          <p class="my-wallet">หมายเลขกระเป๋าของฉัน</p>
          <input
            type="text"
            class="input-wallet"
            ref="ethWallet"
            :value="
              ethereumAddress.slice(0, 22) +
                '....' +
                ethereumAddress.slice(ethereumAddress.length - 4)
            "
            @click="Copy"
            readonly
          />
          <input
            type="text"
            id="ethAddressForCopy"
            :value="ethereumAddress"
            hidden
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";
export default {
  name: "QRCODE",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    qrcode: VueQrcode,
  },
  methods: {
    Copy() {
      try {
        const ethAddressCopy = document.getElementById("ethAddressForCopy");
        ethAddressCopy.select();
        ethAddressCopy.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(ethAddressCopy.value);
        this.alert_show({
          type: "success",
          title: "Copied on clipboard !",
        });
      } catch (err) {}
    },
  },
};
</script>

<style>
.my-wallet {
  font-size: 18px;
}
.input-wallet {
  border: 1px solid #e5e5e5 !important;
  width: 90%;
  border-radius: 50px;
  text-align: center;
  padding: 10px;
  color: #6d6b6b;
  background-color: #f5f5f5;
  font-size: 18px;
}
</style>
